import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo1 from '../assets/logo1.png';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeNavbar();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const section = document.querySelector(targetId);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    } else {
      const section = document.querySelector(targetId);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const closeNavbar = () => {
  const navbar = document.getElementById("navbarNav");
  if (navbar && navbar.classList.contains("show")) {
    navbar.classList.remove("show");
  }
};

  return (
    <nav className={`navbar navbar-expand-lg ${isScrolled ? 'navbar-scrolled shadow-sm' : ''}`}>
      <div className="container">

        {/* Logo */}
        <a className="navbar-brand fw-bold text-white d-flex align-items-center"
           href="/"
           onClick={(e) => handleNavClick(e, '#hero')}
        >
          <img src={logo1} alt="D2D Express Logo" height="50" className="me-2 rounded-circle" />
          <span>D</span><span className="text-danger">2</span><span>D E<span className="text-danger">X</span>PRESS</span>
        </a>

        {/* Toggle */}
        <button
          className="navbar-toggler custom-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav align-items-lg-center">

            <li className="nav-item">
              <a className="nav-link" href="#hero" onClick={(e) => handleNavClick(e, '#hero')}>Home</a>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/tracking" onClick={closeNavbar}>Tracking</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/rate-calculator" onClick={closeNavbar}>Rate Calculator</Link>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>Contact us</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#bookonline" onClick={(e) => handleNavClick(e, '#bookonline')}>Booking</a>
            </li>

            {/* Services Dropdown */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">Services</a>
              <ul className="dropdown-menu custom-dropdown">
                <li><Link className="dropdown-item" to="/sea-freight" onClick={closeNavbar}>Sea Freight</Link></li>
                <li><Link className="dropdown-item" to="/air-freight" onClick={closeNavbar}>Air Freight</Link></li>
                <li><Link className="dropdown-item" to="/warehousing" onClick={closeNavbar}>Warehousing</Link></li>
              </ul>
            </li>

            {/* More Dropdown */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">More</a>
              <ul className="dropdown-menu custom-dropdown">
                <li><Link className="dropdown-item" to="/faqs" onClick={closeNavbar}>FAQs</Link></li>
                <li><Link className="dropdown-item" to="/about" onClick={closeNavbar}>About Us</Link></li>
              </ul>
            </li>
  {/* Login Button */}
  <li className="nav-item ms-lg-3">
    <Link
      to=""
      className="btn btn-danger px-3 py-1 rounded-pill fw-semibold login-btn"
      onClick={closeNavbar}
    >
      Login
    </Link>
  </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
